export default "__VITE_ASSET__ac10986b__"